import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { PackageIcon, FileTextIcon, TicketIcon, UsersIcon, CalendarIcon, AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
export function LicenseDashboard({
  locale,
  onNavigate
}) {
  // Mock data for the dashboard
  const summaryData = {
    totalModules: 8,
    activeModules: 6,
    volumeUsage: {
      current: 75420,
      limit: 100000,
      metric: 'Documents',
      percentage: 75
    },
    occasionalPasses: {
      remaining: 42,
      used: 18,
      total: 60
    },
    activeSessions: 14,
    renewalDue: 45
  };
  const alerts = [{
    id: 'alert-1',
    type: 'warning',
    message: 'Vendor Management module license expires in 7 days',
    action: 'Renew Now',
    module: {
      id: 'module-2',
      name: 'Vendor Management'
    }
  }, {
    id: 'alert-2',
    type: 'danger',
    message: 'Document volume usage at 75% of limit',
    action: 'Upgrade Plan',
    plan: {
      id: 'plan-1',
      name: 'Enterprise Document Plan'
    }
  }];
  return <div className="space-y-6" data-id="element-17932">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-17933">
        {/* Licensed Modules */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17934">
          <div className="px-4 py-5 sm:p-6" data-id="element-17935">
            <div className="flex items-center" data-id="element-17936">
              <div className="flex-shrink-0 bg-indigo-100 rounded-md p-3" data-id="element-17937">
                <PackageIcon className="h-6 w-6 text-indigo-600" data-id="element-17938" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17939">
                <dl data-id="element-17940">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17941">
                    Licensed Modules
                  </dt>
                  <dd data-id="element-17942">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17943">
                      {summaryData.activeModules} / {summaryData.totalModules}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17944">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17945">
                View all modules
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17946" />
              </button>
            </div>
          </div>
        </div>
        {/* Volume Usage */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17947">
          <div className="px-4 py-5 sm:p-6" data-id="element-17948">
            <div className="flex items-center" data-id="element-17949">
              <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-17950">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-17951" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17952">
                <dl data-id="element-17953">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17954">
                    Volume Usage ({summaryData.volumeUsage.metric})
                  </dt>
                  <dd data-id="element-17955">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17956">
                      {summaryData.volumeUsage.current.toLocaleString()} /{' '}
                      {summaryData.volumeUsage.limit.toLocaleString()}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17957">
              <div className="relative" data-id="element-17958">
                <div className="overflow-hidden h-2 text-xs flex rounded bg-blue-100" data-id="element-17959">
                  <div style={{
                  width: `${summaryData.volumeUsage.percentage}%`
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500" data-id="element-17960"></div>
                </div>
                <div className="text-xs text-gray-500 mt-1 text-right" data-id="element-17961">
                  {summaryData.volumeUsage.percentage}% used
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Occasional Passes */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17962">
          <div className="px-4 py-5 sm:p-6" data-id="element-17963">
            <div className="flex items-center" data-id="element-17964">
              <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-17965">
                <TicketIcon className="h-6 w-6 text-green-600" data-id="element-17966" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17967">
                <dl data-id="element-17968">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17969">
                    Occasional Passes
                  </dt>
                  <dd data-id="element-17970">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17971">
                      {summaryData.occasionalPasses.remaining} remaining
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17972">
              <button type="button" onClick={() => onNavigate('passes')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17973">
                Manage passes
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17974" />
              </button>
            </div>
          </div>
        </div>
        {/* Active Sessions */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17975">
          <div className="px-4 py-5 sm:p-6" data-id="element-17976">
            <div className="flex items-center" data-id="element-17977">
              <div className="flex-shrink-0 bg-purple-100 rounded-md p-3" data-id="element-17978">
                <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-17979" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17980">
                <dl data-id="element-17981">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17982">
                    Active Sessions
                  </dt>
                  <dd data-id="element-17983">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17984">
                      {summaryData.activeSessions} today
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17985">
              <button type="button" onClick={() => onNavigate('usage')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17986">
                View usage details
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17987" />
              </button>
            </div>
          </div>
        </div>
        {/* Renewal Due */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17988">
          <div className="px-4 py-5 sm:p-6" data-id="element-17989">
            <div className="flex items-center" data-id="element-17990">
              <div className="flex-shrink-0 bg-yellow-100 rounded-md p-3" data-id="element-17991">
                <CalendarIcon className="h-6 w-6 text-yellow-600" data-id="element-17992" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17993">
                <dl data-id="element-17994">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17995">
                    Next Renewal
                  </dt>
                  <dd data-id="element-17996">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17997">
                      {summaryData.renewalDue} days
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17998">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17999">
                View renewals
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-18000" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Alerts */}
      <div className="bg-white shadow sm:rounded-lg" data-id="element-18001">
        <div className="px-4 py-5 sm:px-6" data-id="element-18002">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-18003">
            License Alerts
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-18004">
            Important notifications about your licenses and usage
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-18005">
          <div className="divide-y divide-gray-200" data-id="element-18006">
            {alerts.map(alert => <div key={alert.id} className="px-4 py-4 sm:px-6" data-id="element-18007">
                <div className="flex items-start" data-id="element-18008">
                  <div className={`flex-shrink-0 ${alert.type === 'warning' ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-18009">
                    <AlertTriangleIcon className="h-5 w-5" data-id="element-18010" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-18011">
                    <p className="text-sm font-medium text-gray-900" data-id="element-18012">
                      {alert.message}
                    </p>
                    <div className="mt-3 flex" data-id="element-18013">
                      <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={() => {
                    if (alert.module) {
                      onNavigate('module-detail', alert.module);
                    } else if (alert.plan) {
                      onNavigate('plan-detail', alert.plan);
                    }
                  }} data-id="element-18014">
                        {alert.action}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
            {alerts.length === 0 && <div className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-18015">
                No alerts at this time. All licenses are in good standing.
              </div>}
          </div>
        </div>
      </div>
    </div>;
}